/* eslint-disable no-redeclare */
import { JourneyAlias, NonEmptyText } from '@hc-frontend/core-types';
import { z } from 'zod';

import { Plate } from './journey';

export const MoveToStartPlateOptions = z.object({
  plate: Plate,
  journeyAlias: JourneyAlias,
});

export type MoveToStartPlateOptions = z.infer<typeof MoveToStartPlateOptions>;

export const StartPlate = z.object({
  url: NonEmptyText,
  searchParams: z.string().optional(),
});

export type StartPlate = z.infer<typeof StartPlate>;
